export const CAMPAGNE = 'Campagne';
export const DISPOSITIF = 'Dispositif';
export const DEMANDE_IMPRESSION = 'DemandeImpression';
export const DEMANDE_INTERVENTION = 'DemandeIntervention';
export const DOCUMENT_VENTE = 'DocumentVente';
export const SOUS_RESEAU = 'SousReseau';
export const CLIENT = 'Client';

export const LISTE_MODULE_TAG_TYPE = [
  { libelle: 'addEditTag.moduleTags.campagne', code: CAMPAGNE },
  { libelle: 'addEditTag.moduleTags.dispositif', code: DISPOSITIF },
  { libelle: 'addEditTag.moduleTags.demandeImpression', code: DEMANDE_IMPRESSION },
  { libelle: 'addEditTag.moduleTags.demandeIntervention', code: DEMANDE_INTERVENTION },
  { libelle: 'addEditTag.moduleTags.documentVente', code: DOCUMENT_VENTE },
  { libelle: 'addEditTag.moduleTags.sousReseau', code: SOUS_RESEAU },
  { libelle: 'addEditTag.moduleTags.client', code: CLIENT },
];
